export default __webpack_public_path__ + "static/media/loveseat-2-seat-1-back.da9a3d1b.webp";